/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIHumanReadableDurationRequest
 */
export interface APIHumanReadableDurationRequest {
    /**
     * 
     * @type {number}
     * @memberof APIHumanReadableDurationRequest
     */
    months: number;
    /**
     * 
     * @type {number}
     * @memberof APIHumanReadableDurationRequest
     */
    weeks: number;
    /**
     * 
     * @type {number}
     * @memberof APIHumanReadableDurationRequest
     */
    days: number;
}

/**
 * Check if a given object implements the APIHumanReadableDurationRequest interface.
 */
export function instanceOfAPIHumanReadableDurationRequest(value: object): value is APIHumanReadableDurationRequest {
    if (!('months' in value) || value['months'] === undefined) return false;
    if (!('weeks' in value) || value['weeks'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    return true;
}

export function APIHumanReadableDurationRequestFromJSON(json: any): APIHumanReadableDurationRequest {
    return APIHumanReadableDurationRequestFromJSONTyped(json, false);
}

export function APIHumanReadableDurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIHumanReadableDurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'months': json['months'],
        'weeks': json['weeks'],
        'days': json['days'],
    };
}

export function APIHumanReadableDurationRequestToJSON(value?: APIHumanReadableDurationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'months': value['months'],
        'weeks': value['weeks'],
        'days': value['days'],
    };
}

